import { Icon } from "@common/index";
import { getPaginationWindow } from "@utils/pagination";

interface OrdersPaginationProps {
    pageNumber: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

// Join-button pager for the order history page, following the customer-facing
// pagination pattern (see ProductGrid's pager). Deliberately NOT
// Common/Pagination: that component carries a mandatory page-size selector,
// and this page is fixed at 10 per page.
export const OrdersPagination = ({
    pageNumber,
    totalPages,
    onPageChange,
}: OrdersPaginationProps) => {
    const pageWindow = getPaginationWindow(pageNumber, totalPages);

    return (
        <nav aria-label="Pagination" className="flex justify-center mt-6">
            <div className="join border border-base-200 bg-primary/10 shadow-sm rounded-lg">
                <button
                    type="button"
                    aria-label="Previous page"
                    className="join-item btn btn-sm btn-ghost text-neutral"
                    disabled={pageNumber <= 1}
                    onClick={() => onPageChange(pageNumber - 1)}
                >
                    <Icon name="chevron_left" className="text-lg" />
                </button>
                {pageWindow.map((entry, i) =>
                    entry === "..." ? (
                        <span
                            key={`ellipsis-${i}`}
                            aria-hidden="true"
                            className="join-item btn btn-sm btn-ghost no-animation pointer-events-none text-neutral/40"
                        >
                            …
                        </span>
                    ) : (
                        <button
                            key={entry}
                            type="button"
                            aria-label={`Go to page ${entry}`}
                            aria-current={
                                entry === pageNumber ? "page" : undefined
                            }
                            className={`join-item btn btn-sm font-bold ${
                                entry === pageNumber
                                    ? "btn-secondary"
                                    : "btn-ghost text-neutral hover:text-neutral"
                            }`}
                            onClick={() => onPageChange(entry)}
                        >
                            {entry}
                        </button>
                    ),
                )}
                <button
                    type="button"
                    aria-label="Next page"
                    className="join-item btn btn-sm btn-ghost text-neutral"
                    disabled={pageNumber >= totalPages}
                    onClick={() => onPageChange(pageNumber + 1)}
                >
                    <Icon name="chevron_right" className="text-lg" />
                </button>
            </div>
        </nav>
    );
};
